import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { GraphMeasure } from '../../../../../../types/graph-data.interface';
import { MeasureChipComponent } from '../measure-chip.component';

@Component({
  selector: 'app-measure-selector-xy',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MeasureChipComponent, TranslocoModule],
  templateUrl: './measure-selector-xy.component.html',
})
export class MeasureSelectorXYComponent {
  readonly selectedMeasureX = input.required<GraphMeasure | null>();
  readonly selectedMeasureY = input.required<GraphMeasure | null>();

  readonly addMeasureX = output<void>();
  readonly configureMeasureX = output<void>();
  readonly removeMeasureX = output<void>();
  readonly addMeasureY = output<void>();
  readonly configureMeasureY = output<void>();
  readonly removeMeasureY = output<void>();
}
